<template>
    <el-dialog class="el-dialogs" :title="title" width="500px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent style="height: 300px"
                 label-width="110px">
            <el-form-item label="模型名称：" prop="modelName">
                <el-input v-model.trim="searchForm.modelName" maxlength="20"
                          placeholder="请输入模型名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="modelState">
                <el-switch
                    v-model="searchForm.modelState"
                    active-value="1"
                    inactive-value="0">
                </el-switch>
                <span class="tipCont">开启后，公开该模型，支持其他人查看和保存为自己的知识模型。</span>
            </el-form-item>
            <el-form-item label="备注：" prop="modelRemark">
                <el-input
                        type="textarea"
                        :rows="5" maxlength="500" resize="none"
                        placeholder="请输入备注(限500字)"
                        v-model.trim="searchForm.modelRemark">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "learningAdd",
    data() {
        return {
            title: '新增模型',
            visible: false,
            searchForm: {
                id:'',
                modelName: '',
                modelRemark: '',
                modelState: '0',
            },
            rules: {
                modelName: [
                    {required: true, message: '请输入模型名称', trigger: 'blur'}
                ],
            },
        }
    },

    methods: {
        init(num, row) {
            this.visible = true
            this.searchForm.id = ''
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (num == 0) {
                this.title = '新增模型'
            }
            if (num == 2) {
                this.title = '编辑模型'
                this.getDetail(row)
            }
        },

        getDetail(row){
            this.$axios(this.api.academic.knowledgemodelGetById + row.id, {}).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key=>{
                        this.searchForm[key] = data.data[key]
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.knowledgemodelUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.knowledgemodelSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.tipCont{
    font-size: 10px;
    padding-left: 10px;
    vertical-align: text-top;
}
</style>